module.exports = __webpack_public_path__ + "static/media/Warehouse.f88c6aa3.svg";